// Timezone formatting utilities

export function getUserTimezone(): string {
  try {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsed = JSON.parse(userData);
      if (parsed.timezone) return parsed.timezone;
    }
  } catch {
    // ignore parse errors
  }
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function formatDateTimeInTimezone(
  isoString: string,
  timezone: string,
  opts?: Intl.DateTimeFormatOptions
): string {
  const defaults: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  };
  return new Intl.DateTimeFormat('en-US', {
    ...(opts || defaults),
    timeZone: timezone,
  }).format(new Date(isoString));
}

export function formatDateOnlyInTimezone(dateStr: string | null | undefined, timezone: string): string {
  if (!dateStr) return '—';
  // If already a full ISO datetime, use as-is; otherwise append noon UTC to avoid off-by-one
  const isoString = dateStr.includes('T') ? dateStr : `${dateStr}T12:00:00Z`;
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: timezone,
  }).format(date);
}

export function isOverdue(dueDateStr: string | null | undefined, timezone: string): boolean {
  if (!dueDateStr) return false;
  const today = new Date(
    new Intl.DateTimeFormat('en-CA', { timeZone: timezone }).format(new Date())
  );
  const isoString = dueDateStr.includes('T') ? dueDateStr : `${dueDateStr}T12:00:00Z`;
  const due = new Date(isoString);
  if (isNaN(due.getTime())) return false;
  return due < today;
}
